import type { FC, JSX, MouseEventHandler } from 'react';
import { Link } from 'react-router-dom';
import './TableActions.scss';
import { IoMdCreate, IoMdTrash, IoIosEyeOff } from 'react-icons/io';

/**
 * Props for the TableActions component
 * @interface TableActionsProps
 */
interface TableActionsProps {
  /** Handler function for delete action */
  onDelete: MouseEventHandler<HTMLButtonElement> | undefined | null;
  /** Handler function for disable action */
  onDisable?: MouseEventHandler<HTMLButtonElement> | undefined | null;
  /** URL for the edit action link */
  editLink: string;
  /** Optional custom buttons to render */
  buttons?: JSX.Element;
}

/**
 * @description TableActions component that renders action buttons for table rows.
 * Provides edit, delete, and disable actions with support for custom buttons.
 *
 * @SADtrace SAD-003-2.1, SAD-003-3.1, SAD-003-4.1
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 *
 * @param {TableActionsProps} props - Component props
 *
 * @returns {JSX.Element} TableActions component
 */
const TableActions: FC<TableActionsProps> = ({
  editLink,
  onDelete,
  onDisable,
  buttons = null,
}) => {
  return (
    <div className="table-actions">
      {!!buttons && buttons}
      {!!editLink && (
        <Link
          className="table-actions-edit"
          data-testid="table-actions-edit"
          to={editLink}
        >
          <span>
            <IoMdCreate style={{ color: '#fff' }} size={18} />
          </span>
        </Link>
      )}
      {!!onDelete && (
        <button
          className="table-actions-delete"
          data-testid="table-actions-delete"
          onClick={onDelete}
        >
          <span>
            <IoMdTrash style={{ color: '#fff', width: 'auto' }} size={20} />
          </span>
        </button>
      )}
      {!!onDisable && (
        <button
          className="table-actions-disable"
          data-testid="table-actions-disable"
          onClick={onDisable}
        >
          <span>
            <IoIosEyeOff style={{ color: '#fff', width: 'auto' }} size={20} />
          </span>
        </button>
      )}
    </div>
  );
};
export default TableActions;
